import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
export class StructuredPafData extends BaseMessage {
    organisationName;
    subBuildingName;
    buildingName;
    buildingNumber;
    pafAddressLines;
    district;
    postTown;
    county;
}
__decorate([
    Field.string({
        required: false,
        description: 'Organisation Name',
    }),
    __metadata("design:type", String)
], StructuredPafData.prototype, "organisationName", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'SubBuildingName',
    }),
    __metadata("design:type", String)
], StructuredPafData.prototype, "subBuildingName", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'BuildingName',
    }),
    __metadata("design:type", String)
], StructuredPafData.prototype, "buildingName", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'BuildingNumber',
    }),
    __metadata("design:type", String)
], StructuredPafData.prototype, "buildingNumber", void 0);
__decorate([
    Field.array({
        items: {
            type: 'string',
        },
        required: false,
        description: 'PafAddressLines',
    }),
    __metadata("design:type", Array)
], StructuredPafData.prototype, "pafAddressLines", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'District',
    }),
    __metadata("design:type", String)
], StructuredPafData.prototype, "district", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'PostTown',
    }),
    __metadata("design:type", String)
], StructuredPafData.prototype, "postTown", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'County',
    }),
    __metadata("design:type", String)
], StructuredPafData.prototype, "county", void 0);
//# sourceMappingURL=StructuredPafData.js.map